// Configuration for resources and utility functions
export const createResourcesAndUtilsConfig = ({
    // Resources
    resources,
    
    // Utility functions
    flattenArr,
    getDateFromTimestamp,
    
    // Event content and state
    eventContent,
    isHoverOpen,
    
    // Mouse event handlers
    onMouseEnter,
    onMouseLeave
}) => ({
    // Resources
    resources,
    
    // Utility functions
    flattenArr,
    getDateFromTimestamp,
    
    // Event content and state
    eventContent,
    isHoverOpen,
    
    // Mouse event handlers
    onMouseEnter,
    onMouseLeave
});

// Default configuration values
export const defaultResourcesAndUtilsConfig = {
    isHoverOpen: false,
    isHoverDayOpen: false
};

